import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
Vue.use(ElementUI);
import install from "@/plugins/install";
import store from "@/store";
import router from './router'


import wow from 'wowjs'
Vue.prototype.$wow = wow
// 全局组件
Vue.use(install);
Vue.config.productionTip = false
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
